import axios from '@/libs/axios'

export default {
  async verify() {
    const response = await axios.get('auth/verify')
    const { data } = response
    return data
  },
  async verifySso() {
    const response = await axios.get('auth/verifySso')
    const { data } = response
    return data
  },
}
